<template>
  <v-container fluid class="pa-0">
    <v-expansion-panels tile multiple accordion flat v-model="panels" @change="saveInvoiceExpansionPanels">
      <v-expansion-panel style="background-color: #ebebeb;">
        <v-expansion-panel-header style="min-height: unset;" ripple>
          <h3 v-text="$t('invoice.header')" />
          <template v-slot:actions>
            <v-icon> mdi-chevron-down </v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-if="ParentOrder" class="px-4 pb-3">
            <v-container class="pa-0" fluid>
              <v-row no-gutters>
                <v-col :cols="isPadBool ? (isPhoneBool ? 12 : 5) :
                  (!ParentOrder || !ParentOrder.CustomerId || (ParentOrder.CustomerId == Customer.Id) ? 4 : 3)"
                  class="d-flex flex-column">
                  <JobOptions />
                </v-col>
                <v-col :cols="isPadBool ? (isPhoneBool ? 12 : 7) : 0" :class="[!isPhoneBool ? 'px-3' : '']">
                  <CustomerInvoiceOptionsCard :customerId="Customer.Id" :customer="Customer" :address="CustomerAddress"
                    :contact="CustomerContact" />
                </v-col>
                <AlternativeCustomerCard :jobId="JobDetails.Id" :customerId="Customer.Id"
                  :alternativeCustomerId="ParentOrder.CustomerId" :alternativeContactId="ParentOrder.CustomerPersonId">
                </AlternativeCustomerCard>
              </v-row>
            </v-container>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel style="background-color: #f5f5f5;">
        <v-expansion-panel-header style="min-height: unset;" ripple>
          <h3 v-text="$t('invoice.machines_kpi')" />
          <template v-slot:actions>
            <v-icon>mdi-chevron-down</v-icon>
          </template>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <div v-if="ParentOrder" class="px-4">
            <div class="d-flex flex-wrap">
              <MachinejobInvoiceOptionsCard v-for="childjob in Subjobs" :key="childjob.Id" :childjob="childjob"
                :repairCodes="repairCodes" :jobCategories="jobCategories">
              </MachinejobInvoiceOptionsCard>
            </div>
          </div>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
    <section-header :title="$t('servicesystem.common_objects.order.order_details')" :leftpad="'pl-4'"
      style="background-color: white;">
      <template v-slot:button>
        <v-checkbox v-model="GroupOrderLinesByMachine"
          :label="$t('servicesystem.common_objects.order.group_lines_by_machine')" class="mt-0 ml-3" dense>
        </v-checkbox>
        <v-spacer></v-spacer>
        <v-bottom-sheet max-width="800" v-model="showInvoicePreview">
          <template v-slot:activator="{ attr, on }">
            <v-btn v-bind="attr" v-on="on" text color="primary" class="px-2" @click="preview">
              <v-icon size="20" class="mr-1">mdi-file-find</v-icon>
              {{ $t('servicesystem.common_objects.commonterms.preview_attachment') }}
            </v-btn>
          </template>
          <v-card :loading="!previewData" loader-height="7">
            <v-card-title>
              {{ $t('servicesystem.common_objects.commonterms.preview_attachment') }}
              <v-spacer />
              <v-btn icon color="secondary" @click="showInvoicePreview = false; previewUrl = null">
                <v-icon>$close</v-icon>
              </v-btn>
            </v-card-title>
            <embed v-if="previewData" :src="previewData" width="800" height="500">
          </v-card>
        </v-bottom-sheet>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" text :min-width="8" color="tertiary" class="mr-3 px-2" :loading="loading"
              @click="sendAttachment">
              <v-icon size="20">mdi-paperclip-plus</v-icon>
            </v-btn>
          </template>
          <span>{{ $t('servicesystem.common_objects.commonterms.send_attachment') }}</span>
        </v-tooltip>
      </template>
    </section-header>
    <OrderLinesCard :groupByMachine="GroupOrderLinesByMachine" :disabled="JobDetails && JobDetails.JobStatusId >= 70" />
  </v-container>
</template>


<script>
import client from "@/api/client";
import clientAPI from "@/api/ClientAPIMixin.js";
import SectionHeader from "@/components/ExpancionPanels/Parts/SectionHeader.vue";
import MachinejobInvoiceOptionsCard from "@/views/job/viewjob/invoice/MachinejobOptions.vue";
import AlternativeCustomerCard from "@/views/job/viewjob/invoice/AlternativeInvoiceCustomerCard.vue";
import CustomerInvoiceOptionsCard from "@/views/job/viewjob/invoice/CustomerInvoiceOptionsCard.vue";
import OrderLinesCard from "@/views/job/viewjob/invoice/OrderLinesCard.vue";
import JobOptions from "@/views/job/viewjob/invoice/ParentOrderOptions.vue";

export default {
  name: "ViewJobInvoice",
  components: {
    SectionHeader,
    CustomerInvoiceOptionsCard,
    AlternativeCustomerCard,
    JobOptions,
    MachinejobInvoiceOptionsCard,
    OrderLinesCard,
  },
  mixins: [clientAPI],

  data() {
    return {
      panels: [],
      previewData: null,
      showInvoicePreview: false,
      drag: false,
      showhidden: true,
      selectmode: false,
      editMode: false,
      loading: false,
      repairCodes: [],
      jobCategories: [],
      total: null,
      lineTypeFilter: [1, 2, 3],
      lineTypes: [
        { Id: 1, text: "Parts" },
        { Id: 2, text: "Hours" },
        { Id: 3, text: "Other" },
      ],
    };
  },

  mounted() {
    this.loadInvoiceExpansionPanels();
    if (this.JobDetails && this.isValidId(this.JobDetails.Id)) {
      this.getJob();
    }
    this.getAllRepairCodes();
    this.getAllJobCategories();
    //setTimeout(() => this.$store.dispatch("JobHub/JobUpdater/triggerUpdateOrderTotals"), 3000)
  },

  methods: {
    sendAttachment() {
      this.loading = true;
      client()
        .post("api2/serviceprovider/invoice/attachpdf/" + this.$route.params.jobId).finally(() => {
          this.loading = false;
        });
    },

    saveInvoiceExpansionPanels() {
      localStorage.setItem("invoiceexpansionpanels", JSON.stringify(this.panels));
    },

    loadInvoiceExpansionPanels() {
      const expandedPanels = localStorage.getItem("invoiceexpansionpanels");
      if (!expandedPanels) {
        this.panels = [];
      } else {
        this.panels = JSON.parse(expandedPanels);
      }
    },

    getJob() {
      this.$store.dispatch("JobHub/JobUpdater/triggerUpdateCompleteOrder");
    },

    async getAllRepairCodes() {
      this.getRepairCodes()
        .then((response) => {
          this.repairCodes = response;
        })
        .catch(() => { })
        .finally(() => { });
    },

    async getAllJobCategories() {
      this.getJobCategories()
        .then((response) => {
          this.jobCategories = response;
        })
        .catch(() => { })
        .finally(() => { });
    },

    preview() {
      this.previewData = null;
      client()
        .get("api2/serviceprovider/invoice/pdf/" + this.$route.params.jobId, {
          responseType: "arraybuffer",
        })
        .catch((e) => {
          this.showInvoicePreview = false;
          this.$store.dispatch("triggerevents/responseSnackbar", {
            response: e,
            method: "preview",
            text: null,
            input: { jobId: this.$route.params.jobId },
          });
        })
        .then((response) => {
          //const blob = new Blob([response.data], ['appliction/pdf']);
          //const objectUrl = URL.createObjectURL(blob);
          //this.previewData = objectUrl;
          this.previewData = "data:application/pdf;base64," + Buffer.from(response.data, "binary").toString("base64");
        });
    },

    updateValue() { },
  },

  computed: {
    JobDetails() {
      return this.$store.getters["JobHub/JobDetails"];
    },
    ParentOrder() {
      return this.$store.getters["JobHub/ParentOrder"];
    },
    Subjobs() {
      return this.$store.getters["JobHub/Subjobs"];
    },
    Customer() {
      return this.$store.getters["JobHub/Customer"];
    },
    CustomerAddress() {
      return this.$store.getters["JobHub/CustomerDeliveryAdress"];
    },
    CustomerContact() {
      return this.$store.getters["JobHub/CustomerContact"];
    },
    GroupOrderLinesByMachine: {
      get() {
        return this.$store.getters["prefrences/Prefrence"]("GroupOrderLinesByMachine");
      },
      set(update) {
        //console.log(update);
        this.$store.dispatch("prefrences/set_prefrence", { key: "GroupOrderLinesByMachine", value: update });
      },
    },
  },

  watch: {
    "JobDetails.Id": function () {
      this.getJob();
    },
  },
};
</script>


<style lang="scss" scoped>
::v-deep .v-input--checkbox .v-label {
  font-size: 13px !important;
  margin-left: 4px;
}
</style>